import { configureStore } from '@reduxjs/toolkit';
import userReducers from "./reducers/userReducers";

const reducer = {
	user: userReducers
}

export const store = configureStore({ reducer });